import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Settings as ManageIcon, Groups as SquadIcon, } from "@mui/icons-material";
import { Avatar, Box, Card, CardContent, Chip, Divider, IconButton, Stack, Typography, } from "@mui/material";
import { Link } from "react-router-dom";
import { PlayerAvatar } from "../players/PlayerAvatar";
import { playerDisplayName } from "../players/PlayerDisplayNameLink";
var MAX_PLAYERS_TO_SHOW = 5;
export var SquadCard = function (_a) {
    var players = _a.players, teamId = _a.teamId, title = _a.title, _b = _a.canModify, canModify = _b === void 0 ? false : _b;
    var activePlayers = teamId ? players.filter(function (p) { return p.isActive; }) : players;
    var truncate = !!teamId;
    var showViewAll = truncate && activePlayers.length > MAX_PLAYERS_TO_SHOW;
    var playersToDisplay = truncate
        ? activePlayers.slice(0, MAX_PLAYERS_TO_SHOW)
        : activePlayers;
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsxs(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: 2,
                    }, children: [title ? (title) : (_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [_jsx(Typography, { variant: "h6", sx: { fontWeight: 600 }, children: "Squad" }), activePlayers.length > 0 && (_jsx(Chip, { label: activePlayers.length, size: "small", sx: {
                                        backgroundColor: "rgba(25, 118, 210, 0.1)",
                                        color: "primary.main",
                                        fontWeight: 600,
                                        minWidth: 24,
                                    } }))] })), canModify && teamId && (_jsx(IconButton, { component: Link, to: "/teams/".concat(teamId, "/squad/"), role: "button", size: "small", title: "Manage squad", sx: {
                                color: "text.secondary",
                                "&:hover": {
                                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                                    transform: "scale(1.05)",
                                },
                                transition: "all 0.2s ease",
                            }, children: _jsx(ManageIcon, {}) }))] }), _jsx(Divider, { sx: { mb: 2 } }), _jsx(Stack, { spacing: 0, children: playersToDisplay.length > 0 ? (playersToDisplay.map(function (player, index) { return (_jsx(Link, { to: "/players/".concat(player.id, "/"), style: { textDecoration: "none", color: "inherit" }, children: _jsxs(Box, { sx: {
                                py: 1.5,
                                px: 2,
                                display: "flex",
                                alignItems: "center",
                                "&:hover": {
                                    backgroundColor: "#f8f9ff",
                                },
                                transition: "all 0.2s ease",
                                borderBottom: index < playersToDisplay.length - 1
                                    ? "1px solid rgba(0,0,0,0.08)"
                                    : "none",
                            }, children: [_jsx(Box, { sx: {
                                        width: 36,
                                        textAlign: "center",
                                        mr: 2,
                                        flexShrink: 0,
                                    }, children: player.squadNumber !== null &&
                                        player.squadNumber !== undefined ? (_jsx(Typography, { variant: "h6", sx: {
                                            fontWeight: 700,
                                            lineHeight: 1,
                                            color: "text.primary",
                                        }, children: player.squadNumber })) : (_jsx(Typography, { variant: "h6", sx: {
                                            fontWeight: 700,
                                            lineHeight: 1,
                                            color: "text.disabled",
                                        }, children: "\u2013" })) }), _jsx(PlayerAvatar, { player: player, size: 40 }), _jsx(Box, { sx: { ml: 2, flex: 1 }, children: _jsx(Typography, { variant: "body1", sx: { fontWeight: 600 }, children: playerDisplayName(player) }) })] }) }, player.id)); })) : (_jsxs(Box, { sx: { p: 4, textAlign: "center" }, children: [_jsx(Avatar, { sx: {
                                    width: 56,
                                    height: 56,
                                    backgroundColor: "rgba(25, 118, 210, 0.1)",
                                    color: "primary.main",
                                    mx: "auto",
                                    mb: 2,
                                }, children: _jsx(SquadIcon, { sx: { fontSize: 28 } }) }), _jsx(Typography, { variant: "h6", color: "text.secondary", sx: { mb: 1 }, children: "No players yet" }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: "Add players to build your squad" })] })) }), showViewAll && (_jsx(Box, { sx: {
                        p: 2,
                        textAlign: "center",
                        backgroundColor: "rgba(25, 118, 210, 0.02)",
                        borderTop: "1px solid rgba(0,0,0,0.08)",
                        mt: 1,
                    }, children: _jsx(Link, { to: "/teams/".concat(teamId, "/squad/"), style: { textDecoration: "none" }, children: _jsxs(Typography, { variant: "body2", sx: {
                                color: "primary.main",
                                fontWeight: 500,
                                "&:hover": {
                                    textDecoration: "underline",
                                },
                            }, children: ["View all ", activePlayers.length, " players \u2192"] }) }) })), teamId && (_jsx(Box, { sx: {
                        p: 2,
                        textAlign: "center",
                        backgroundColor: "rgba(25, 118, 210, 0.02)",
                        borderTop: "1px solid rgba(0,0,0,0.08)",
                        mt: showViewAll ? 0 : 1,
                    }, children: _jsx(Link, { to: "/teams/".concat(teamId, "/formation/"), style: { textDecoration: "none" }, children: _jsx(Typography, { variant: "body2", sx: {
                                color: "primary.main",
                                fontWeight: 600,
                                "&:hover": {
                                    textDecoration: "underline",
                                },
                            }, children: "Build a Formation \u2192" }) }) }))] }) }));
};
